exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-d2a86e6e]{margin:0}.announcement-detail[data-v-d2a86e6e]{margin-bottom:2rem}.announcement-detail .label[data-v-d2a86e6e]{margin-bottom:.25rem}.announcement-detail .value[data-v-d2a86e6e]{font-weight:700}.announcement-date-range[data-v-d2a86e6e]{display:flex;gap:6rem}", ""]);

// exports
